import React, { PropsWithChildren, ReactNode } from "react"
import styled, { css } from "styled-components"

import Checkbox from "~/components/atoms/Checkbox"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import ActionPairButton from "~/components/molecules/ActionPairButton"
import { Color, IsMobile, RadiusSize, SpacingSize, Z } from "~/consts/style-mixins"

interface IProps {
  note?: string | ReactNode
  checkbox: {
    values: any[]
    items: {
      text: string
      value: any
    }[]
    onClick: (next: any) => void
  }
  mainAction: {
    label: string
    action: Function
    className?: string
    disabled?: boolean
    isLoading?: boolean
  }
  subAction: {
    label: string
    action: Function
    className?: string
    disabled?: boolean
    isLoading?: boolean
  }
  labelName?: string
}

/** @deprecated ~/components/molecules/Dialog を使用する */
export const SelectModalContainer = (props: PropsWithChildren<Omit<IProps, "checkbox">>) => {
  const { mainAction, subAction, labelName, note, children } = props
  return (
    <Container>
      <Background>
        <StyledWrapper>
          <Typography type="Heading">{labelName ? `${labelName}を選択してください` : "選択してください"}</Typography>
          {note && <Typography type="Note">{note}</Typography>}

          <StyledOptions>{children}</StyledOptions>

          <StyledAction>
            <ActionInner>
              <ActionPairButton mainAction={mainAction} subAction={subAction} />
            </ActionInner>
          </StyledAction>
        </StyledWrapper>
      </Background>
    </Container>
  )
}

/** @deprecated ~/components/molecules/Dialog と ~/components/atoms/Checkbox を使用する */
const SelectModal: React.FC<IProps> = ({ checkbox, ...props }) => {
  return (
    <SelectModalContainer {...props}>
      <Pc>
        <Checkbox columnNumber={2} {...checkbox} />
      </Pc>
      <Sp>
        <Checkbox columnNumber={1} {...checkbox} />
      </Sp>
    </SelectModalContainer>
  )
}

export default SelectModal

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: ${Z.Modal};
`

const StyledWrapper = styled.div`
  position: relative;
  background: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  padding: ${SpacingSize.XL}px ${SpacingSize.XL}px 0;
  width: 100%;
  max-width: 640px;
  max-height: calc(100vh - 64px);
  overflow-y: scroll;
  margin: auto;
  ${IsMobile(css`
    max-height: calc(100vh - 108px);
  `)}
`

const Background = styled.div`
  background: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${SpacingSize.M}px;
`

const StyledOptions = styled.div`
  margin-top: ${SpacingSize.XL}px;
`

const StyledAction = styled.div`
  position: sticky;
  bottom: 0;
  padding: ${SpacingSize.XL}px 0;
  background: ${Color.White};
`
const ActionInner = styled.div`
  max-width: 480px;
  margin: auto;
`
